import { AccrualProfileTable } from 'components/table/accrual_profile/Table';

const AccrualProfiles = () => {
    return (
        <>
            <AccrualProfileTable />
        </>
    );
}

export { AccrualProfiles };